import { Box, IconButton, Title, Text, Link } from '@nimbus-ds/components';
import { CloseIcon } from '@nimbus-ds/icons';
import './BannerMobile.scss';
import { Trans } from 'react-i18next';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';
import bannerImageMobile from './img/banner-ne-mobile.png';

interface BannerMobileProps {
  onClick: () => void;
  onClose: () => void;
  translateKey: string;
}

function BannerMobile({
  onClick,
  onClose,
  translateKey,
}: Readonly<BannerMobileProps>) {
  const t = useNuvemEnvioTranslations();

  return (
    <div className="stratus-en-banner-mobile">
      <div className="banner__close">
        <IconButton
          onClick={onClose}
          backgroundColor="transparent"
          color="neutral-interactive"
          source={<CloseIcon size="small" color="neutral-interactive" />}
        />
      </div>
      <Box display="flex" gap="4" padding="4">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="1"
        >
          <div className="banner__image">
            <img
              src={bannerImageMobile}
              alt={t(`${translateKey}.title`)}
              width="92px"
              aria-hidden="true"
              decoding="async"
            />
          </div>
        </Box>

        <Box display="flex" flexDirection="column" flex="3">
          <Box
            display="flex"
            flexDirection="column"
            gap="1"
            flex="1"
            maxWidth="90%"
          >
            <div className="banner__title">
              <Title as="h3" fontSize="3-5">
                {t(`${translateKey}.title`)}
              </Title>
            </div>
          </Box>
          <Text color="primary-textLow" fontSize="caption">
            <Trans
              t={t}
              i18nKey={`${translateKey}.subtitle`}
              components={{ bold: <strong />, 1: <p /> }}
            />
          </Text>
          <Link
            as="button"
            onClick={onClick}
            appearance="primary"
            textDecoration="none"
          >
            {t(`${translateKey}.button`)}
          </Link>
        </Box>
      </Box>
    </div>
  );
}

export default BannerMobile;
